// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__31j35","right":"styles_right__2qKHc"};